export default __webpack_public_path__ + "static/media/profileIcon.050b69b3.png";